export class StatusEventPagePastDataRequestParameters {
  startTimestamp: number = 0;
  endTimestamp: number = 0;
  pageNumber: number = 0;
  limit: number = 0;
  signalNames: string[] = [];
  eventTypes: string [] = [];
  sortBy: string = 'timestamp';
  sortDirection: SORT_DIRECTION = 'DESC';

  constructor(startTimestamp: number, endTimestamp: number, pageNumber: number, limit: number, signalNames: string[], eventTypes: string[], sortBy: string, sortDirection: SORT_DIRECTION) {
    this.startTimestamp = startTimestamp;
    this.endTimestamp = endTimestamp;
    this.pageNumber = pageNumber;
    this.limit = limit;
    this.signalNames = signalNames;
    this.eventTypes = eventTypes;
    if (sortBy === 'sortableType') {
      this.sortBy = 'type';
    } else {
      this.sortBy = sortBy;
    }
    this.sortDirection = sortDirection;
  }
}

export type SORT_DIRECTION = 'ASC' | 'DESC';
